module.exports = __webpack_public_path__ + "img/thai_qr_payment.c4e8fc8d.png";